import {useCallback} from 'react';

import {useAccountStatuses} from 'src/hooks/dictionaries';

import {COLUMNS} from '../constants';

import type {AccountSearchResult} from 'src/openapi/admin/models/AccountSearchResult';

export const useGetColumnValue = () => {
    const {getAccountStatusByCode} = useAccountStatuses();

    const getColumnValue = useCallback((columnId: string, account: AccountSearchResult) => {
        switch (columnId) {
            case COLUMNS.ACCOUNT_NAME:
                return account[columnId as keyof AccountSearchResult] || '';
            case COLUMNS.ACCOUNT_STATUS:
                return getAccountStatusByCode(account.accountStatus)?.description || '';
            default:
                return '';
        }
    }, [getAccountStatusByCode]);

    return {getColumnValue};
};
